<template>
  <footer>
    <router-link to="/" style="display: inline-block"
      ><img src="@assets/img/main/footer_logo.svg" alt="푸터로고"
    /></router-link>
    <!--약관-->
    <div class="footer-terms">
      <a
        @click="
          () => {
            return alertStore.showAlertDialog('준비중입니다');
          }
        "
        >회사소개</a
      >
      <router-link :to="{ name: ROUTE_NAME.ServiceTerms }"
        >이용약관</router-link
      >
      <router-link :to="{ name: ROUTE_NAME.PrivacyTerms }"
        >개인정보처리방침</router-link
      >
      <router-link :to="{ name: ROUTE_NAME.VideoInformation }"
        >영상정보처리기기 운영방침</router-link
      >
      <router-link :to="{ name: ROUTE_NAME.PrivacyEmail }"
        >이메일무단수집거부</router-link
      >
    </div>
    <div class="footer-info">
      (주)블루원 대표자명 : 김봉호 사업자등록번호 : 505-81-81749 통신판매업신고
      : 제 2014-경북경주-0170호<br />
      경기도 용인시 처인구 원삼면 보개원삼로1534번길 40
      <span>copyright (c) 2016 blueone. all rights reserved.</span>
      <p>1899-1888</p>
    </div>
    <!--페이스북-->
    <div class="social-icon">
      <a href="http://pf.kakao.com/_xfxdxmbj" target="_blank" class="kakao"
        ><img src="@assets/img/main/footer_kakao.svg" alt="카카오톡"
      /></a>
      <a href="https://naver.me/5y4qUYF3" target="_blank" class="naver"
        ><img src="@assets/img/main/footer_naver.svg" alt="네이버플레이스"
      /></a>
      <a
        href="https://www.instagram.com/blueone_yongin_c.c"
        target="_blank"
        class="instagram"
        ><img src="@assets/img/main/footer_instagram.svg" alt="인스타그램"
      /></a>
    </div>
    <!--패밀리 사이트맵-->
    <div class="family-map">
      <div
        class="list-title"
        :class="{ open: familyList.list }"
        @click="familyList.list = !familyList.list"
      >
        <p>FAMILY SITE</p>
        <span class="icon" :class="{ active: familyList.list }"></span>
      </div>

      <ul class="list-content">
        <li>
          <a href="https://ty-holdings.co.kr/" target="_blank">TY 홀딩스</a>
        </li>
        <li>
          <a href="https://www.taeyoung.com/" target="_blank">태영건설</a>
        </li>
        <li><a href="https://www.sbs.co.kr/" target="_blank">SBS</a></li>
        <li>
          <a href="https://www.speedium.co.kr/" target="_blank">인제스피디움</a>
        </li>
      </ul>
    </div>
  </footer>
</template>
<script setup lang="ts">
import { ROUTE_NAME } from '@constants';
import { reactive } from 'vue';
import { useAlertStore } from '@stores';

const alertStore = useAlertStore();
const familyList = reactive({
  list: false,
});
</script>

<style scoped lang="scss">
footer {
  background: #414141;
  color: #9b9b9b;
  width: 100%;
  height: 450px;
  padding: 43px 0 38px;
  position: relative;
  left: 0;
  bottom: 0;
  text-align: center;
}
footer img {
  margin: 0 auto;
}

.footer-terms {
  margin: 15px 0;
  display: flex;
  gap: 20px;
  justify-content: center;
}

.footer-info {
  line-height: 24px;
  font-size: 14px;
}
.footer-info span {
  display: block;
  text-transform: uppercase;
  margin-top: 10px;
}
.footer-info p {
  margin: 12px 0 19px;
  font-size: 25px;
}

.social-icon {
  display: flex;
  justify-content: center;
  gap: 0 10px;
  img {
    width: 26px;
    height: 26px;
  }
}

.family-map {
  width: 164px;
  margin: 20px auto 0 auto;
  border: 1px solid #9b9b9b;
  position: relative;
  .list-title {
    font-size: 16px;
    color: #9b9b9b;
    text-align: center;
    display: block;
    padding: 6px 0;
    cursor: pointer;
  }
  .list-content {
    display: none;
    position: absolute;
    top: -130px;
    left: 50%;
    transform: translateX(-50%);
    background: #fff;
    width: calc(100% + 1px);
    li {
      text-align: left;
      font-size: 14px;
      border-bottom: 1px solid #626262;
      color: #898989;
      a {
        display: block;
        padding: 5px 10px;
      }
    }
  }
  .list-title.open ~ .list-content {
    display: block;
  }
  .icon {
    position: absolute;
    right: 15px;
    top: 55%;
    transform: translateY(-50%);
    display: block;
    width: 25px;
    height: 25px;
    background: url('@assets/img/contents/icon_footer-plus.svg') no-repeat
      center center;
  }
  .icon.active {
    background: url('@assets/img/contents/icon_footer-minus.svg') no-repeat
      center center;
  }
}
</style>
